<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Tipos de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5 mb-3">
    <div class="col">
      <h3>Listado de respuestas</h3>
      <p>Configurar las reglas de negocio correspondientes por respuesta</p>
    </div>
    <div class="col text-right">
      <a
        routerLink="../../../ChecklistConfiguracion/{{ idTipoRevision }}"
        class="btn btn-sm btn-primary mr-4"
      >
        <i class="fa fa-check"></i> Terminar
      </a>
      <button (click)="publicar()" class="btn btn-sm btn-green">
        <i class="fa fa-upload"></i> Publicar
      </button>
    </div>
  </div>
  <div class="card mt-2" *ngFor="let bloque of bloques">
    <div class="card-body">
      <h3 class="card-title">Bloque: {{ bloque.Nombre }}</h3>
      <div class="card mt-2" *ngFor="let rubro of bloque.Rubros">
        <div class="card-body">
          <h6 class="card-title">Rubro: {{ rubro.Nombre }}</h6>
          <div class="card mt-2" *ngFor="let pregunta of rubro.Preguntas">
            <div class="card-body">
              <h6 class="card-title">Pregunta: {{ pregunta.Descripcion }}</h6>
              <div
                class="card mt-2"
                *ngFor="let respuesta of pregunta.Respuestas"
              >
                <div class="card-body">
                  <h6 class="card-title">Respuesta: {{ respuesta.Label }}</h6>
                  <div *ngFor="let tipoReglaNegocio of tiposReglasNegocio">
                    <div
                      class="row mt-1 pb-1 pt-1 border-top"
                      *ngIf="
                        restrictionRespuestaTipoRegla(
                          respuesta.IdTipoInput,
                          tipoReglaNegocio.IdTipoReglaNegocio
                        )
                      "
                    >
                      <div class="col-md-10">
                        <p>
                          {{ tipoReglaNegocio.Descripcion }}
                        </p>
                      </div>
                      <div class="col-md-1 text-center">
                        <div
                          *ngIf="
                            [1].includes(tipoReglaNegocio.IdTipoReglaNegocio)
                          "
                        >
                          <button
                            *ngIf="
                              existsRule(
                                respuesta.TiposReglasNegocio,
                                tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            class="btn btn-sm btn-success rounded-circle"
                          >
                            <i class="fa fa-check"></i>
                          </button>
                          <button
                            *ngIf="
                              !existsRule(
                                respuesta.TiposReglasNegocio,
                                tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            class="btn btn-sm btn-primary rounded-circle"
                            (click)="
                              postRule(
                                tipoReglaNegocio.IdTipoReglaNegocio,
                                respuesta
                              )
                            "
                          >
                            <i class="fa fa-check"></i>
                          </button>
                        </div>
                        <div
                          *ngIf="
                            [2, 3, 4, 5].includes(
                              tipoReglaNegocio.IdTipoReglaNegocio
                            )
                          "
                        >
                          <button
                            *ngIf="
                              existsRule(
                                respuesta.TiposReglasNegocio,
                                tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            (click)="
                              configRule(
                                rubro,
                                pregunta.IdPregunta,
                                respuesta,
                                tipoReglaNegocio.IdTipoReglaNegocio,
                                respuesta.IdRelacion +
                                  '-' +
                                  tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            class="btn btn-sm btn-success rounded-circle"
                          >
                            <i class="fa fa-list"></i>
                          </button>
                          <button
                            *ngIf="
                              !existsRule(
                                respuesta.TiposReglasNegocio,
                                tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            (click)="
                              configRule(
                                rubro,
                                pregunta.IdPregunta,
                                respuesta,
                                tipoReglaNegocio.IdTipoReglaNegocio,
                                respuesta.IdRelacion +
                                  '-' +
                                  tipoReglaNegocio.IdTipoReglaNegocio
                              )
                            "
                            class="btn btn-sm btn-primary rounded-circle"
                          >
                            <i class="fa fa-list"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-1 text-center">
                        <button
                          disabled
                          class="btn btn-sm btn-secondary rounded-circle"
                          *ngIf="
                            !existsRule(
                              respuesta.TiposReglasNegocio,
                              tipoReglaNegocio.IdTipoReglaNegocio
                            )
                          "
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <button
                          class="btn btn-sm btn-danger rounded-circle"
                          *ngIf="
                            existsRule(
                              respuesta.TiposReglasNegocio,
                              tipoReglaNegocio.IdTipoReglaNegocio
                            )
                          "
                          (click)="
                            deleteRule(
                              tipoReglaNegocio.IdTipoReglaNegocio,
                              respuesta
                            )
                          "
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modalRules"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalRulesTitle"
  aria-hidden="true"
>
  <form
    id="formRules"
    (submit)="formRules($event)"
    class="mt-5 mb-3"
    ngNativeValidate
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalRulesTitle">
            Configuración de regla de fechas
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="card mt-2" *ngFor="let bloque of bloques">
            <div class="card-body">
              <h3 class="card-title">Bloque: {{ bloque.Nombre }}</h3>
              <div class="card mt-2" *ngFor="let rubro of bloque.Rubros">
                <div class="card-body">
                  <h6 class="card-title">Rubro: {{ rubro.Nombre }}</h6>
                  <div class="card mt-2">
                    <div class="card-body">
                      <div class="row" *ngFor="let pregunta of rubro.Preguntas">
                        <div class="col">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input
                              [disabled]="
                                idPreguntaPivot == pregunta.IdPregunta
                              "
                              type="checkbox"
                              class="custom-control-input"
                              id="{{ pregunta.IdPregunta }}"
                              name="cbPreguntasForRules"
                            />
                            <label
                              style="font-weight: 500"
                              class="custom-control-label"
                              for="{{ pregunta.IdPregunta }}"
                              >{{ pregunta.Descripcion }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="modalRuleFecha"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalRuleFechaTitle"
  aria-hidden="true"
>
  <form
    id="formRuleFecha"
    (submit)="formRules($event)"
    class="mt-5 mb-3"
    ngNativeValidate
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalRuleFechaTitle">
            Configuración de regla de fechas
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="rule4AntiguedadDias"
                  >Limite de antiguedad (Dias):</label
                >
                <input
                  [disabled]="
                    ReglaNegocioAntiguedadFecha.FlagValidacionRespuestaPivote
                  "
                  required
                  class="form-control"
                  type="number"
                  id="rule4AntiguedadDias"
                  name="rule4AntiguedadDias"
                  [(ngModel)]="ReglaNegocioAntiguedadFecha.AntiguedadDias"
                  min="0"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="rule4Ponderacion"
                  >Ponderación fuera de tiempo:</label
                >
                <input
                  required
                  class="form-control"
                  type="number"
                  id="rule4Ponderacion"
                  name="rule4Ponderacion"
                  [(ngModel)]="ReglaNegocioAntiguedadFecha.Ponderacion"
                  min="0"
                  max="100"
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="custom-control custom-checkbox mr-sm-2">
            <input
              type="checkbox"
              id="cbValidate"
              class="custom-control-input"
              [(ngModel)]="
                ReglaNegocioAntiguedadFecha.FlagValidacionRespuestaPivote
              "
              [ngModelOptions]="{ standalone: true }"
            />
            <label
              style="font-weight: 500"
              class="custom-control-label"
              for="cbValidate"
              >Validar la antiguedad con respuesta pivote</label
            >
          </div>
          <div
            class="card mt-2"
            *ngIf="ReglaNegocioAntiguedadFecha.FlagValidacionRespuestaPivote"
          >
            <div class="card-body">
              <h6>Selecciona una respuesta pivote para la antiguedad</h6>
              <h6 class="card-title">Rubro: {{ rubroPivote.Nombre }}</h6>
              <div
                class="card mt-2"
                *ngFor="let pregunta1 of rubroPivote.Preguntas"
              >
                <div class="card-body">
                  <h6 class="card-title">
                    Pregunta: {{ pregunta1.Descripcion }}
                  </h6>
                  <div
                    class="row"
                    *ngFor="let respuesta1 of pregunta1.Respuestas"
                  >
                    <div class="col">
                      <div class="custom-control custom-radio mr-sm-2">
                        <input
                          [disabled]="idRelacionPivot == respuesta1.IdRelacion"
                          type="radio"
                          id="{{ respuesta1.IdRelacion }}"
                          name="cbRespuestasForRules"
                          class="custom-control-input"
                          required
                        />
                        <label
                          style="font-weight: 500"
                          class="custom-control-label"
                          for="{{ respuesta1.IdRelacion }}"
                          >{{ respuesta1.Label }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="modalRuleRangoNumerico"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalRuleRangoNumericoTitle"
  aria-hidden="true"
>
  <form
    id="formRuleRangoNumerico"
    (submit)="formRules($event)"
    class="mt-5 mb-3"
    ngNativeValidate
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalRuleRangoNumericoTitle">
            Configuración de regla de rango numerico
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="rule5Valor">Valor base:</label>
                <input
                  [disabled]="
                    ReglaNegocioRangoNumerico.FlagValidacionRespuestaPivote
                  "
                  required
                  class="form-control"
                  type="number"
                  id="rule5Valor"
                  name="rule5Valor"
                  [(ngModel)]="ReglaNegocioRangoNumerico.Valor"
                  min="0"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="rule5Porcentaje">Porcentaje:</label>
                <input
                  required
                  class="form-control"
                  type="number"
                  id="rule5Porcentaje"
                  name="rule5Porcentaje"
                  [(ngModel)]="ReglaNegocioRangoNumerico.PorcentajePermitido"
                  min="0"
                  max="100"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="rule5Ponderacion"
                  >Ponderación fuera de rango:</label
                >
                <input
                  required
                  class="form-control"
                  type="number"
                  id="rule5Ponderacion"
                  name="rule5Ponderacion"
                  [(ngModel)]="ReglaNegocioRangoNumerico.Ponderacion"
                  min="0"
                  max="100"
                />
              </div>
            </div>
          </div>

          <hr />
          <div class="custom-control custom-checkbox mr-sm-2">
            <input
              type="checkbox"
              id="cbValidateRN"
              class="custom-control-input"
              [(ngModel)]="
                ReglaNegocioRangoNumerico.FlagValidacionRespuestaPivote
              "
              [ngModelOptions]="{ standalone: true }"
            />
            <label
              style="font-weight: 500"
              class="custom-control-label"
              for="cbValidateRN"
              >Valor numerico con respuesta pivote</label
            >
          </div>
          <div
            class="card mt-2"
            *ngIf="ReglaNegocioRangoNumerico.FlagValidacionRespuestaPivote"
          >
            <div class="card-body">
              <h6>Selecciona una respuesta pivote para la antiguedad</h6>
              <h6 class="card-title">Rubro: {{ rubroPivote.Nombre }}</h6>
              <div
                class="card mt-2"
                *ngFor="let pregunta1 of rubroPivote.Preguntas"
              >
                <div class="card-body">
                  <h6 class="card-title">
                    Pregunta: {{ pregunta1.Descripcion }}
                  </h6>
                  <div
                    class="row"
                    *ngFor="let respuesta1 of pregunta1.Respuestas"
                  >
                    <div class="col">
                      <div class="custom-control custom-radio mr-sm-2">
                        <input
                          [disabled]="idRelacionPivot == respuesta1.IdRelacion"
                          type="radio"
                          id="RN-{{ respuesta1.IdRelacion }}"
                          name="cbRespuestasForRulesRN"
                          class="custom-control-input"
                          required
                        />
                        <label
                          style="font-weight: 500"
                          class="custom-control-label"
                          for="RN-{{ respuesta1.IdRelacion }}"
                          >{{ respuesta1.Label }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
